import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import AdminCreateUserForm from "composer/views/admin/AdminCreateUserForm.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Tabs, Tab, Button, IconButton, Tooltip, TextField, Icon, FormControl, Select } from '@material-ui/core';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

class AdminTaskDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeTab: 0,
      searchText: "",
      totalPage: 0,
      currentPage: 0,
      newUser: {
        username: "",
        displayName: "",
        email: "",
        password0: "",
        password1: "",
        accessRight: 0,
        schoolID: "",
      },
      tableRows: [],
    };
    autoBind(this);
  }

  getTasks() {
    return [Localization.strings.CREATE_USER, Localization.strings.USER_LIST, Localization.strings.CREATE_SCHOOL, Localization.strings.SCHOOL_LIST];
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (newIndex == index) {
      return;
    }
    newIndex = index;
    this.setState({
      activeTab: newIndex,
      searchText: "",
      tableRows: [],
    });
    this.state.activeTab = newIndex;
    this.state.searchText = "";
    this.state.tableRows = [];
  }

  handleTabChange = (event, index) => {
    this.changeTab(index);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.setState({ activeTab: 0 });
    this.state.activeTab = 0;
    this.close();
  }

  userList() {
    return [
      this.pageNavigator(),
      <TextField key="searchText"
        value={this.state.searchText}
        onChange={this.searchTextChanged}
        placeholder={Localization.strings.SEARCH + "..."}
        onKeyPress={this.handleSearchEnterPressed}
        margin="dense"
      />,
      <Tooltip key="searchTooltip" title={Localization.strings.SEARCH}>
        <IconButton
          onClick={this.handleSearchClicked}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip>,
      <Table key="userTable">
        <TableHead>
          <TableRow>
            <TableCell>編號</TableCell>
            <TableCell>帳號名稱</TableCell>
            <TableCell>顯示名稱</TableCell>
            <TableCell>電郵</TableCell>
            <TableCell>權限</TableCell>
            <TableCell>學校名稱</TableCell>
            <TableCell>最近登入</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            this.state.tableRows.map((row, i) => (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
            ))
          }
        </TableBody>
      </Table>
    ];
  }

  schoolList() {
    return [
      <Table key="schoolTable">
        <TableHead>
          <TableRow>
            <TableCell>編號</TableCell>
            <TableCell>學校名稱</TableCell>
            <TableCell>學校名稱(Eng)</TableCell>
            <TableCell>地區</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>類別</TableCell>
          </TableRow>
        </TableHead>
      </Table>
    ];
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

  handleSearchClicked() {

  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  previosPage() {
    let page = this.state.currentPage;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePage(page);
  }

  nextPage() {
    let page = this.state.currentPage;
    page++;
    if (page > this.state.totalPage - 1) {
      page = this.state.totalPage - 1;
    }
    this.changePage(page);
  }

  pageChanged(e) {
    let page = e.target.value;
    this.setState({ currentPage: page});
    this.state.currentPage = page;
    this.refreshList();
  }

  refreshList() {

  }

  pageNavigator() {
    let pages = [];
    for (let i = 0; i < this.state.totalPage; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{padding:'0 12px 0 0', display:'inline-block'}}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select
          value={this.state.currentPage}
          onChange={this.pageChanged}
        >
        </Select>
      </FormControl>,
      <IconButton
        onClick={this.previosPage}
        disabled={this.state.currentPage <= 0}
      >
        <Icon>keyboard_arrow_left</Icon>
      </IconButton>,
      <IconButton
        onClick={this.nextPage}
        disabled={this.state.currentPage + 1 >= this.state.totalPage}
      >
        <Icon>keyboard_arrow_right</Icon>
      </IconButton>
    ];
  }

  render() {
    let tasks = this.getTasks();
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.ADMIN_TASK}
          </DialogTitle>

          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{padding:'0 0 14px 0'}}
            >
              {tasks.map((label, index) => {
                return (
                  <Tab key={index} label={label}/>
                );
              })}
            </Tabs>
            <Switch condition={this.state.activeTab}>
              <Case value={0}>
                <AdminCreateUserForm parent={this} root={this.props.root} refs="adminCreateUserForm" />
              </Case>
              <Case value={1}>
                {this.userList()}
              </Case>
              <Case value={3}>
                {this.schoolList()}
              </Case>
            </Switch>
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleClose}
            >
              {Localization.strings.DONE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default AdminTaskDialog;
